import { createFileRoute } from '@tanstack/react-router';

import { AccessControlProfilesContainer } from '@/features/access-control-profiles/containers';

export const Route = createFileRoute('/_layout/access-control-profiles/')({
  component: AccessControlProfilesContainer,
});
